import React, { FC, useEffect, useState } from "react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../../../Components/ui/select";
import { Input } from "../../../Components/ui/input";
import { Label } from "../../../Components/ui/label";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "../../../Components/ui/dialog";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "../../../Components/ui/dropdown-menu";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../../../Components/ui/table";
import { useToast } from "../../../Components/ui/use-toast";
import { Toaster } from "../../../Components/ui/toaster";
import { Button } from "../../../Components/ui/button";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../State/store";
import { DotsHorizontalIcon } from "@radix-ui/react-icons";
import { CircularProgress } from "@mui/material";
import { useLocation } from "react-router-dom";
import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from "../../../Components/ui/tabs";
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from "../../../Components/ui/card";
import { Textarea } from "../../../Components/ui/textarea";

interface ConnectSMSProps {
  open: boolean;
  handleClose: () => void;
  checkIsAlive: (serverId: number, channelId: number) => Promise<string>;
  connectionList: connectionList[] | undefined;
}

interface ShortCodes {
  code: string;
}

interface connectionList {
  id: number;
  channelName: string;
  type: string;
  host: string;
  port: number;
  systemId: string;
  password: string;
  created_date: string;

  // New TON & NPI fields
  bindingTON: number;
  bindingNPI: number;
  senderTON: number;
  senderNPI: number;
  destinationTON: number;
  destinationNPI: number;
  bindMode: number;
  systemType: string;
  addressRange: string;
  transportProtocol: string;
  transport_Protocal: string;
  bind_Mode: number;
  address_Range: string;
  system_Type: string;
  service_Type: string;
  data_Coding: number;
  character_Encoding: string;
}

export const ConnectSMS: FC<{
  open: boolean;
  handleClose: () => void;
  checkIsAlive: (serverId: number, channelId: number) => Promise<string>;
  connectionList: connectionList[] | undefined;
  isEditMode: boolean;
  setIsEdit: (value: boolean) => void;
  shortCodes: string;
}> = ({
  open,
  handleClose,
  checkIsAlive,
  connectionList,
  isEditMode,
  setIsEdit,
  shortCodes,
}) => {
  const smsUrl = useSelector((state: RootState) => state.authentication.smsUrl);
  const toast = useToast();

  const [connectionName, setConnectionName] = useState("");
  const [serverType, setServerType] = useState("SMPP");
  const [host, setHost] = useState("");
  const [port, setPort] = useState("");
  const [username, setUsername] = useState("");
  // const [serverType, setServerType] = useState("SMPP");
  const [password, setPassword] = useState("");
  const [activeTab, setActiveTab] = useState("basic");
  const location = useLocation();
  const serverId = location.state?.serverId || " ";

  // New State Variables for TON & NPI
  const [bindingTON, setBindingTON] = useState(0);
  const [bindingNPI, setBindingNPI] = useState(0);
  const [senderTON, setSenderTON] = useState(5);
  const [senderNPI, setSenderNPI] = useState(0);
  const [destinationTON, setDestinationTON] = useState(1);
  const [destinationNPI, setDestinationNPI] = useState(1);
  const [shortCode, setShortCode] = useState([
    {
      code: "000",
    },
  ]);

  const [transportProtocol, setTransportProtocol] = useState("TCP");
  const [bindMode, setBindMode] = useState("Transceiver");
  const [addressRange, setAddressRange] = useState("");
  const [systemType, setSystemType] = useState("");
  const [dataCodingScheme, setDataCodingScheme] = useState("8");
  const [characterEncoding, setCharacterEncoding] = useState("UTF-8");
  const [serviceType, setServiceType] = useState("CMT");
  const [connectionId, setConnectionId] = useState(0);

  if (isEditMode && connectionList) {
  }

  useEffect(() => {
    console.log("Is this Edit Mode ? & Dialog Opened ", isEditMode, "  ", open);
    if (open && isEditMode && connectionList) {
      setConnectionId(connectionList[0].id);
      setConnectionName(connectionList[0].channelName);
      setHost(connectionList[0].host);
      setPort(connectionList[0].port?.toString() ?? "");
      setUsername(connectionList[0].systemId);
      setPassword(connectionList[0].password);
      setBindingTON(Number(connectionList[0].bindingTON));
      setBindingNPI(Number(connectionList[0].bindingNPI));
      setSenderTON(Number(connectionList[0].senderTON));
      setSenderNPI(Number(connectionList[0].senderNPI));
      setDestinationTON(Number(connectionList[0].destinationTON));
      setDestinationNPI(Number(connectionList[0].destinationNPI));

      setTransportProtocol(connectionList[0].transport_Protocal);

      if (connectionList[0].bind_Mode) {
        var value = connectionList[0].bind_Mode.toString();
        if (value === "3") {
          value = "Transceiver";
        } else if (value === "2") {
          value = "Receiver";
        } else if (value === "1") {
          value = "Transmitter";
        }
        setBindMode(value);
      }

      setAddressRange(connectionList[0].address_Range);
      setSystemType(connectionList[0].system_Type);
      setServiceType(connectionList[0].service_Type);
      setDataCodingScheme(connectionList[0].data_Coding.toString());
      setCharacterEncoding(connectionList[0].character_Encoding);
      console.log(shortCodes);
      if (shortCodes) {
        console.log(shortCodes);
        const parsedShortCodes = JSON.parse(shortCodes); // ["777", "435", "222"]
        const formattedShortCodes: ShortCodes[] = parsedShortCodes.map(
          (code: string) => ({
            code,
          })
        );
        setShortCode(formattedShortCodes);
      }
    }
  }, [open, isEditMode, setIsEdit]);

  const connectionResolver = (item: string, value: string) => {
    if (item === "bindMode") {
      if (value === "Transceiver") {
        return 3;
      } else if (value === "Receiver") {
        return 2;
      } else if (value === "Transmitter") {
        return 1;
      }
    }
  };

  const handleConnect = async (channelId: number) => {
    // Validate all fields before making API call
    if (!validateAllFields()) {
      toast.toast({
        title: "Validation Error",
        description: "Please fill all required fields before connecting.",
      });
      return; // Stop API call if validation fails
    }

    debugger;
    try {
      const response = await axios.post(
        `${smsUrl}/connect?ServerId=${serverId}`,
        {
          Host: host,
          Port: port,
          SystemId: username,
          Password: password,
          channelId: channelId,
          BindingTON: bindingTON, // Added Binding TON
          BindingNPI: bindingNPI, // Added Binding NPI
          BindMode: Number(connectionResolver("bindMode", bindMode)),
          SystemType: systemType,
          AddressRange: addressRange,
          UseSSL: transportProtocol === "TCP" ? false : true,
        }
      );

      if (response.data.status === "Success") {
        checkIsAlive(serverId, channelId);
        toast.toast({
          title: "Success",
          description: "Connected Successfully",
        });
      } else {
        toast.toast({
          title: "Failure",
          description: "Could not connect with SMPP server",
        });
      }
    } catch (error) {
      toast.toast({ title: "Failure", description: "API call failed" });
    }
  };

  const validateAllFields = () => {
    if (
      !connectionName.trim() ||
      !host.trim() ||
      !port.trim() ||
      !username.trim() ||
      !password.trim()
    ) {
      toast.toast({
        title: "Validation Error",
        description: "Please fill all required fields.",
      });
      return false;
    }
    return true;
  };

  const handleInputChange = (name: string, value: string | number) => {
    switch (name) {
      case "connectionName":
        setConnectionName(value as string);
        break;
      case "host":
        setHost(value as string);
        break;
      case "port":
        setPort(value as string);
        break;
      case "username":
        setUsername(value as string);
        break;
      case "password":
        setPassword(value as string);
        break;
      case "bindingTON":
        setBindingTON(Number(value));
        break;
      case "bindingNPI":
        setBindingNPI(Number(value));
        break;
      case "senderTON":
        setSenderTON(Number(value));
        break;
      case "senderNPI":
        setSenderNPI(Number(value));
        break;
      case "destinationTON":
        setDestinationTON(Number(value));
        break;
      case "destinationNPI":
        setDestinationNPI(Number(value));
        break;
    }
  };

  const checkconnectionName = () => {
    if (
      connectionList?.some(
        (data) =>
          data.channelName.toLowerCase().trim() ===
          connectionName.toLowerCase().trim()
      )
    ) {
      toast.toast({
        title: "Connection name already exists",
        description: "Please use differnt connection name.",
      });
      return true;
    }
    console.log("Not Exists");
    return false;
  };

  const createChannel = async () => {
    if (!validateAllFields()) return;

    if (!isEditMode && checkconnectionName()) {
      console.log("EXITS");
      return;
    }

    try {
      //   debugger
      //   console.log("The Connection Data : ",data);
      var response;
      if (isEditMode) {
        response = await axios.put(
          `${smsUrl}/updateconnection?ServerId=${serverId}&ConnectionId=${connectionId}`,
          {
            ChannelName: connectionName || "",
            Type: serverType,
            Host: host || "",
            Port: port || 0,
            SystemId: username || "",
            Password: password || "",
            ServerId: serverId || 0,
            BindingTON: bindingTON || 0,
            BindingNPI: bindingNPI || 0,
            SenderTON: senderTON || 0,
            SenderNPI: senderNPI || 0,
            DestinationTON: destinationTON || 0,
            DestinationNPI: destinationNPI || 0,
            ShortCodes:
              shortCode.length > 0
                ? JSON.stringify(shortCode.map((sc) => sc.code))
                : "[]",
            TransportProtocol: transportProtocol || "",
            BindMode: Number(connectionResolver("bindMode", bindMode)),
            AddressRange: addressRange || "",
            SystemType: systemType || "",
            DataCodingScheme: dataCodingScheme || 0,
            CharacterEncoding: characterEncoding || "",
            ServiceType: serviceType || "",
          }
        );
      } else {
        response = await axios.post(`${smsUrl}/createconnection`, {
          ChannelName: connectionName || "",
          Type: serverType,
          Host: host || "",
          Port: port || 0,
          SystemId: username || "",
          Password: password || "",
          ServerId: serverId || 0,
          BindingTON: bindingTON || 0,
          BindingNPI: bindingNPI || 0,
          SenderTON: senderTON || 0,
          SenderNPI: senderNPI || 0,
          DestinationTON: destinationTON || 0,
          DestinationNPI: destinationNPI || 0,
          ShortCodes:
            shortCode.length > 0
              ? JSON.stringify(shortCode.map((sc) => sc.code))
              : "[]",
          TransportProtocol: transportProtocol || "",
          BindMode: Number(connectionResolver("bindMode", bindMode)),
          AddressRange: addressRange || "",
          SystemType: systemType || "",
          DataCodingScheme: dataCodingScheme || 0,
          CharacterEncoding: characterEncoding || "",
          ServiceType: serviceType || "",
        });
      }

      if (response.data.status === "Success") {
        toast.toast({
          title: "Success",
          description: isEditMode?"Server details updated successfully":"Server details stored successfully",
        });
        handleConnect(isEditMode ? connectionId : response?.data?.channel_id);
        handleClose();
      } else {
        toast.toast({
          title: "Error",
          description: isEditMode?"Failed to update server details":"Failed to store server details",
        });
      }
    } catch (error) {
      console.error("Error storing server details:", error);
    }
  };

  const handleTabChange = (tab: string) => {
    setActiveTab(tab);
  };

  const addShortCode = () => {
    setShortCode([
      ...shortCode,
      {
        code: "000",
      },
    ]);
  };

  const removeShortCode = (index: number) => {
    const updatedShortCodes = shortCode.filter((_, i) => i !== index);
    setShortCode(updatedShortCodes);
  };

  const shortCodeChange = (
    index: number,
    field: keyof ShortCodes,
    value: string
  ) => {
    const updatedShortCode = [...shortCode];
    updatedShortCode[index] = {
      ...updatedShortCode[index],
      [field]: value,
    } as unknown as ShortCodes;
    setShortCode(updatedShortCode);
  };

  useEffect(() => {
    if (!open) {
      setIsEdit(false);
    }
  }, [open]);

  return (
    <Dialog open={open} onOpenChange={handleClose}>
      <Toaster />
      <DialogContent className="overflow-y-auto max-h-[90%] p-8 mt-2 mb-6">
        <Tabs
          value={activeTab}
          onValueChange={setActiveTab}
          className="w-full h-full"
        >
          <TabsList className="grid w-full grid-cols-2">
            <TabsTrigger value="basic">Basic</TabsTrigger>
            <TabsTrigger value="advanced">Advanced</TabsTrigger>
          </TabsList>

          {/* Basic Configuration */}
          <TabsContent value="basic">
            <Card>
              <CardContent className="space-y-2 p-6 pt-8 flex flex-col gap-2">
                <div>
                  <Label className="text-[#020617] text-14px font-medium">
                    Connection Name
                  </Label>
                  <Input
                    value={connectionName}
                    className="mt-2"
                    onChange={(e) =>
                      handleInputChange("connectionName", e.target.value)
                    }
                  />
                </div>

                <div className="flex flex-col">
                  <Label
                    htmlFor="server-type"
                    className="text-14px font-medium text-[#020617] mt-2"
                  >
                    Connection Type
                  </Label>
                  <Select
                    value={serverType}
                    onValueChange={(value) => setServerType(value)}
                  >
                    <SelectTrigger className="text-gray-500 mt-2 flex items-center justify-between px-3">
                      <SelectValue
                        placeholder="Select Type of SMS Channel"
                        className="text-[#64748B] text-sm font-normal mt-2"
                      />
                    </SelectTrigger>
                    <SelectContent>
                      <SelectItem
                        className="text-[#64748B] text-sm font-normal cursor-pointer"
                        value="SMPP"
                      >
                        SMPP
                      </SelectItem>
                      <SelectItem
                        className="text-[#64748B] text-sm font-normal cursor-pointer"
                        value="REST"
                      >
                        REST API
                      </SelectItem>
                    </SelectContent>
                  </Select>
                </div>
                {serverType === "SMPP" && (
                  <>
                    <div className="flex gap-2">
                      <div className="w-[50%]">
                        <Label className="mb-2 text-[#020617] text-14px font-medium">
                          Host
                        </Label>
                        <Input
                          value={host}
                          className="mt-2"
                          onChange={(e) =>
                            handleInputChange("host", e.target.value)
                          }
                        />
                      </div>

                      <div className="w-[50%]">
                        {" "}
                        <Label className="mb-2 text-[#020617] text-14px font-medium">
                          Port
                        </Label>
                        <Input
                          value={port}
                          className="mt-2"
                          onChange={(e) =>
                            handleInputChange("port", e.target.value)
                          }
                        />
                      </div>
                    </div>

                    <div>
                      <Label className="mb-2 text-[#020617] text-14px font-medium">
                        Username
                      </Label>
                      <Input
                        value={username}
                        className="mt-2"
                        onChange={(e) =>
                          handleInputChange("username", e.target.value)
                        }
                      />
                    </div>

                    <div>
                      <Label className="mb-1 text-[#020617] text-14px font-medium">
                        Password
                      </Label>
                      <Input
                        type="password"
                        className="mt-2"
                        value={password}
                        onChange={(e) =>
                          handleInputChange("password", e.target.value)
                        }
                      />
                    </div>

                    <div className="flex flex-col">
                      <Label className="mb-2 text-[#020617] text-14px font-medium">
                        Short Codes
                      </Label>

                      {shortCode.map((code, index) => (
                        <div
                          key={index}
                          className="flex items-center gap-2 mb-1"
                        >
                          <Input
                            autoFocus
                            value={code.code}
                            onChange={(e) =>
                              shortCodeChange(index, "code", e.target.value)
                            }
                            className="w-full"
                          />

                          {shortCode.length > 1 && (
                            <span>
                              <button onClick={() => removeShortCode(index)}>
                                ✕
                              </button>
                            </span>
                          )}
                        </div>
                      ))}

                      <div className="flex justify-end">
                        <Button
                          className="w-[30%] mt-0"
                          variant="link"
                          onClick={() => {
                            addShortCode();
                          }}
                        >
                          + Add
                        </Button>
                      </div>
                    </div>
                  </>
                )}
              </CardContent>
              <CardFooter>
                <Button
                  className="w-full"
                  onClick={() => setActiveTab("advanced")}
                >
                  Next
                </Button>
              </CardFooter>
            </Card>
          </TabsContent>

          <TabsContent value="advanced">
            <Card>
              <CardContent className="space-y-2 p-6 pt-8 flex flex-col gap-4">
                {serverType === "SMPP" && (
                  <>
                    <div className="flex flex-col gap-2">
                      <Label
                        htmlFor="binding-address"
                        className="text-14px font-medium text-[#020617]"
                      >
                        Binding Address
                      </Label>

                      <div
                        className="flex w-full items-center gap-2"
                        id="binding-address"
                      >
                        <Label
                          htmlFor="binding-address"
                          className="text-14px font-medium text-[#020617]"
                        >
                          TON
                        </Label>
                        <Input
                          id="binding-address"
                          type="number"
                          value={bindingTON}
                          onChange={(e) =>
                            handleInputChange("bindingTON", e.target.value)
                          }
                          className="text-[14px] font-normal placeholder:text-[#64748B] w-[47%]"
                        />

                        <Label
                          htmlFor="binding-address"
                          className="text-14px font-medium text-[#020617]"
                        >
                          NPI
                        </Label>
                        <Input
                          id="binding-address"
                          type="number"
                          value={bindingNPI}
                          onChange={(e) =>
                            handleInputChange("bindingNPI", e.target.value)
                          }
                          className="text-[14px] font-normal placeholder:text-[#64748B] w-[47%]"
                        />
                      </div>
                    </div>

                    <div className="flex flex-col gap-2">
                      <Label
                        htmlFor="binding-address"
                        className="text-14px font-medium text-[#020617]"
                      >
                        Sender Address
                      </Label>

                      <div
                        className="flex w-full items-center gap-2"
                        id="binding-address"
                      >
                        <Label
                          htmlFor="binding-address"
                          className="text-14px font-medium text-[#020617]"
                        >
                          TON
                        </Label>
                        <Input
                          id="binding-address"
                          type="number"
                          value={senderTON}
                          onChange={(e) =>
                            handleInputChange("senderTON", e.target.value)
                          }
                          className="text-[14px] font-normal placeholder:text-[#64748B]"
                        />

                        <Label
                          htmlFor="binding-address"
                          className="text-14px font-medium text-[#020617]"
                        >
                          NPI
                        </Label>
                        <Input
                          id="binding-address"
                          type="number"
                          value={senderNPI}
                          onChange={(e) =>
                            handleInputChange("senderNPI", e.target.value)
                          }
                          className="text-[14px] font-normal placeholder:text-[#64748B]"
                        />
                      </div>
                    </div>

                    <div className="flex flex-col gap-2">
                      <Label
                        htmlFor="binding-address"
                        className="text-14px font-medium text-[#020617]"
                      >
                        Destination Address
                      </Label>

                      <div
                        className="flex w-full gap-2 items-center"
                        id="binding-address"
                      >
                        <Label
                          htmlFor="binding-address"
                          className="text-14px font-medium text-[#020617]"
                        >
                          TON
                        </Label>
                        <Input
                          id="binding-address"
                          type="number"
                          value={destinationTON}
                          onChange={(e) =>
                            handleInputChange("destinationTON", e.target.value)
                          }
                          className="text-[14px] font-normal placeholder:text-[#64748B] w-[47%]"
                        />

                        <Label
                          htmlFor="binding-address"
                          className="text-14px font-medium text-[#020617]"
                        >
                          NPI
                        </Label>
                        <Input
                          id="binding-address"
                          type="number"
                          value={destinationNPI}
                          onChange={(e) =>
                            handleInputChange("destinationNPI", e.target.value)
                          }
                          className="text-[14px] font-normal placeholder:text-[#64748B] w-[47%]"
                        />
                      </div>
                    </div>

                    <div className="flex flex-col gap-2">
                      <Label className="text-14px font-medium text-[#020617]">
                        Transport Protocol
                      </Label>
                      <Select
                        value={transportProtocol}
                        onValueChange={setTransportProtocol}
                      >
                        <SelectTrigger>
                          <SelectValue placeholder="Select Protocol" />
                        </SelectTrigger>
                        <SelectContent>
                          <SelectItem value="TCP">TCP</SelectItem>
                          <SelectItem value="SSL">SSL</SelectItem>
                        </SelectContent>
                      </Select>
                    </div>

                    <div className="flex flex-col gap-2">
                      <Label className="text-14px font-medium text-[#020617]">
                        Bind Mode
                      </Label>
                      <Select value={bindMode} onValueChange={setBindMode}>
                        <SelectTrigger>
                          <SelectValue placeholder="Select Bind Mode" />
                        </SelectTrigger>
                        <SelectContent>
                          <SelectItem value="Transceiver">
                            Transceiver
                          </SelectItem>
                          <SelectItem value="Receiver">Receiver</SelectItem>
                          <SelectItem value="Transmitter">
                            Transmitter
                          </SelectItem>
                        </SelectContent>
                      </Select>
                    </div>

                    <div className="flex flex-col gap-2">
                      <Label className="text-14px font-medium text-[#020617]">
                        Address Range
                      </Label>
                      <Input
                        type="text"
                        value={addressRange}
                        onChange={(e) => setAddressRange(e.target.value)}
                        className="text-[14px] font-normal placeholder:text-[#64748B]"
                      />
                    </div>

                    <div className="flex flex-col gap-2">
                      <Label className="text-14px font-medium text-[#020617]">
                        System Type
                      </Label>
                      <Input
                        type="text"
                        value={systemType}
                        onChange={(e) => setSystemType(e.target.value)}
                        className="text-[14px] font-normal placeholder:text-[#64748B]"
                      />
                    </div>

                    <div className="flex flex-col gap-2">
                      <Label className="text-14px font-medium text-[#020617]">
                        Service Type
                      </Label>
                      <Input
                        type="text"
                        value={serviceType}
                        onChange={(e) => setServiceType(e.target.value)}
                        className="text-[14px] font-normal placeholder:text-[#64748B]"
                      />
                    </div>

                    <div className="flex flex-col gap-2">
                      <Label className="text-14px font-medium text-[#020617]">
                        Data Coding Scheme
                      </Label>
                      <Input
                        type="text"
                        value={dataCodingScheme}
                        onChange={(e) => setDataCodingScheme(e.target.value)}
                        className="text-[14px] font-normal placeholder:text-[#64748B]"
                      />
                    </div>

                    <div className="flex flex-col gap-2">
                      <Label className="text-14px font-medium text-[#020617]">
                        Character Encoding
                      </Label>
                      <Select
                        value={characterEncoding}
                        onValueChange={setCharacterEncoding}
                      >
                        <SelectTrigger>
                          <SelectValue placeholder="Select Encoding" />
                        </SelectTrigger>
                        <SelectContent>
                          <SelectItem value="UTF-8">UTF-8</SelectItem>
                          <SelectItem value="UTF-16">UTF-16</SelectItem>
                        </SelectContent>
                      </Select>
                    </div>
                  </>
                )}
              </CardContent>
              <CardFooter className="flex w-full flex-end justify-end">
                <Button
                  className="w-[30%] "
                  onClick={() => {
                    handleTabChange("basic");
                  }}
                >
                  Back
                </Button>

                <Button
                  className="w-[30%] ml-[40%]"
                  onClick={() => {
                    createChannel();
                  }}
                >
                  {isEditMode ? "Update" : "Submit"}
                </Button>
              </CardFooter>
            </Card>
          </TabsContent>
        </Tabs>
      </DialogContent>
    </Dialog>
  );
};

const SmsConnections: FC = () => {
  const smsUrl = useSelector((state: RootState) => state.authentication.smsUrl);
  const toast = useToast();
  const [open, setOpen] = useState(false);
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState(false);
  const [openMenuRowId, setOpenMenuRowId] = useState<number | null>(null);
  const [connectionList, setConnectionList] = useState<connectionList[]>();
  const [connectionStatus, setConnectionStatus] = useState<
    Record<number, string>
  >({});
  const location = useLocation();
  const serverId = location.state?.serverId || " ";
  const [shortcodes, setShortCodes] = useState("");

  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    getConnectionList();
    setOpen(false);
  };

  const dispatch = useDispatch();

  const checkIsAlive = async (
    serverId: number,
    channelId: number
  ): Promise<string> => {
    // Set initial loading status using channelId as key
    setConnectionStatus((prev) => ({ ...prev, [channelId]: "Loading..." }));
    try {
      const response = await axios.get(
        `${smsUrl}/isAlive?serverId=${serverId}&ConnectionId=${channelId}`
      );
      if (response.data.status === "Success") {
        setConnectionStatus((prev) => ({ ...prev, [channelId]: "Connected" }));
        return "Connected";
      } else {
        setConnectionStatus((prev) => ({
          ...prev,
          [channelId]: "Disconnected",
        }));
        return "Disconnected";
      }
    } catch (error) {
      setConnectionStatus((prev) => ({ ...prev, [channelId]: "Error" }));
      return "Disconnected";
    }
  };

  const checkIsAliveForconnectionList = async (serverId: number) => {
    try {
      setConnectionStatus((prev) => ({ ...prev, [serverId]: "Loading..." }));
      const response = await axios.get(
        `${smsUrl}/isServerAlive?serverId=${serverId}`
      );
      if (response.data.status === "Success") {
        setConnectionStatus((prev) => ({ ...prev, [serverId]: "Connected" }));
      } else {
        setConnectionStatus((prev) => ({
          ...prev,
          [serverId]: "Disconnected",
        }));
      }
    } catch (error) {
      setConnectionStatus((prev) => ({ ...prev, [serverId]: "Disconnected" }));
      console.error(
        `Error checking connection status for server ${serverId}:`,
        error
      );
    }
  };

  const handleReconnect = async (
    channelId: number,
    host: string,
    port: number,
    username: string,
    password: string,
    bindingTON: number,
    bindingNPI: number,
    bindMode: number,
    systemType: string,
    addressRange: string,
    transportProtocol: string
  ) => {
    try {
      const response = await axios.post(
        `${smsUrl}/connect?ServerId=${serverId}`,
        {
          Host: host,
          Port: port,
          SystemId: username,
          Password: password,
          channelId: channelId,
          BindingTON: bindingTON, // Added Binding TON
          BindingNPI: bindingNPI, // Added Binding NPI
          BindMode: bindMode,
          SystemType: systemType,
          AddressRange: addressRange,
          UseSSL: transportProtocol === "TCP" ? false : true,
        }
      );

      if (response.data.status === "Success") {
        checkIsAlive(serverId, channelId);
        toast.toast({
          title: "Success",
          description: "Connected Successfully",
        });
      } else {
        toast.toast({
          title: "Failure",
          description: "Could not connect with SMPP server",
        });
      }
    } catch (error) {
      toast.toast({ title: "Failure", description: "SMPP Connection Failed" });
    }
  };

  const handleDisconnect = async (channelId: number) => {
    try {
      const response = await axios.post(
        `${smsUrl}/disconnect?serverId=${serverId}&ConnectionId=${channelId}`
      );
      if (response.data.status === "Success") {
        checkIsAlive(serverId, channelId);
        toast.toast({
          title: "Success",
          description: "Disconnected from SMPP server",
        });
        getConnectionList();
      } else {
        toast.toast({
          title: "Error",
          description: "Could not disconnect SMPP server",
        });
      }
    } catch (error) {
      console.error("API error in disconnecting from SMPP server: ", error);
    }
  };

  const handleEditConnection = async (connectionId: number) => {
    try {
      console.log("Connection Id :", connectionId);
      const response = await axios.get(
        `${smsUrl}/getconnectionsById?ServerId=${serverId}&ConnectionId=${connectionId}`
      );
      if (response.data.status === "Success") {
        var connectionList = response.data.connectionList;
        console.log("Data :", connectionList);
        setConnectionList(connectionList);
        console.log("ShortCodes :", connectionList[0].sms_ShortCodes);
        setShortCodes(connectionList[0].sms_ShortCodes);
        setIsEdit(true);
        setOpen(true);
      } else {
        console.error("List of connections not found");
      }
    } catch (e) {
      console.log("Error :", e);
    }
  };

  const handleDeleteConnection = async (connectionId: number) => {
    try {
      // Call the delete connection API endpoint
      const response = await axios.delete(
        `${smsUrl}/deleteconnection?connectionId=${connectionId}`
      );

      if (
        response.data.status === "Success" &&
        response.data.status_Description ===
          "Connection deleted and archived successfully."
      ) {
        // Show success message
        toast.toast({
          title: "Success",
          description: "Connection deleted successfully",
        });

        getConnectionList();
      } else {
        toast.toast({
          title: "Error",
          description: "Failed to delete connection",
        });
      }
    } catch (error) {
      console.error("Error in deleting connection: ", error);

      // Show error toast
      toast.toast({
        title: "Error",
        description: "Could not delete connection. Please try again.",
      });
    }
  };

  const handleMenuToggle = (rowId: number) => {
    debugger;
    setOpenMenuRowId(openMenuRowId === rowId ? null : rowId);
  };

  const getConnectionList = async () => {
    setIsLoading(true);
    setIsEdit(false);
    try {
      const response = await axios.get(
        `${smsUrl}/getconnections?ServerId=${serverId}`
      );
      if (response.data.status === "Success") {
        setConnectionList(response.data.connectionList);
        response.data.connectionList.forEach((connection: connectionList) => {
          checkIsAlive(serverId, connection.id);
        });
      } else {
        console.error("List of connections not found");
      }
    } catch (error) {
      console.error("Error getting connection list: ", error);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    getConnectionList();
  }, []);

  const handleCreateConnection = () => {
    setIsEdit(false);
    setOpen(true);
  };

  return (
    <>
      {isLoading ? (
        <div className="flex items-center justify-center h-[500px]">
          <CircularProgress />
        </div>
      ) : (
        <div>
          {connectionList ? (
            <div className="flex w-full flex-col h-full">
              <div className="flex w-full justify-end">
                <Button
                  onClick={handleOpen}
                  className="w-36 text-sm font-thin h-[35px] mt-1 mb-6"
                >
                  Create Connection
                </Button>
              </div>
              <div>
                <div className="rounded-md border overflow-hidden">
                  <div className="max-h-[60vh] overflow-y-auto">
                    <Table className="rounded-xl border-[#020202]">
                      <TableHeader className="text-center text-[14px] font-medium">
                        <TableRow className="sticky top-0 bg-white z-10">
                          <TableHead>
                            <div className="flex items-center gap-6 justify-start cursor-pointer">
                              <span className="font-medium text-[14px] text-[#64748B]">
                                Connection Name
                              </span>
                            </div>
                          </TableHead>
                          <TableHead>
                            <div className="flex items-center gap-2 justify-start">
                              <span className="font-medium text-[14px] text-[#64748B]">
                                Username
                              </span>
                            </div>
                          </TableHead>
                          <TableHead>
                            <div className="flex items-center gap-2">
                              <span className="font-medium text-[14px] text-[#64748B]">
                                Host
                              </span>
                            </div>
                          </TableHead>
                          <TableHead>
                            <div className="flex items-center gap-2">
                              <span className="font-medium text-[14px] text-[#64748B]">
                                Status
                              </span>
                            </div>
                          </TableHead>
                          <TableHead></TableHead>
                        </TableRow>
                      </TableHeader>

                      <TableBody className="text-left text-[14px] font-normal text-[#020617]">
                        {connectionList.map((connection) => (
                          <TableRow key={connection.id}>
                            <TableCell className="flex justify-start py-4">
                              <div className="flex items-center gap-6">
                                <span
                                  style={{
                                    color: "#020617",
                                    fontSize: "14px",
                                    fontWeight: "400",
                                  }}
                                >
                                  {connection.channelName}
                                </span>
                              </div>
                            </TableCell>
                            <TableCell className="py-4">
                              <span
                                style={{
                                  color: "#020617",
                                  fontSize: "14px",
                                  fontWeight: "400",
                                }}
                              >
                                {connection.systemId || "N/A"}
                              </span>
                            </TableCell>
                            <TableCell className="py-4">
                              <span
                                style={{
                                  color: "#020617",
                                  fontSize: "14px",
                                  fontWeight: "400",
                                }}
                              >
                                {connection.host || "N/A"}
                              </span>
                            </TableCell>
                            <TableCell className="py-4">
                              <span
                                style={{
                                  color: "#020617",
                                  fontSize: "14px",
                                  fontWeight: "400",
                                }}
                              >
                                {connectionStatus[connection.id] ||
                                  "Disconnected"}
                              </span>
                            </TableCell>
                            <TableCell className="py-4">
                              <DropdownMenu>
                                <DropdownMenuTrigger asChild>
                                  <DotsHorizontalIcon
                                    onClick={() =>
                                      handleMenuToggle(connection.id)
                                    }
                                    className="cursor-pointer w-6 h-6"
                                  />
                                </DropdownMenuTrigger>
                                {openMenuRowId === connection.id && (
                                  <DropdownMenuContent
                                    align="end"
                                    // className="w-20 bg-gray-200"
                                  >
                                    {connectionStatus[connection.id] ===
                                    "Connected" ? (
                                      <DropdownMenuItem
                                        className="cursor-pointer"
                                        onClick={() =>
                                          handleDisconnect(connection.id)
                                        }
                                      >
                                        Disconnect
                                      </DropdownMenuItem>
                                    ) : connectionStatus[connection.id] ===
                                      "Disconnected" ? (
                                      <DropdownMenuItem
                                        className="cursor-pointer"
                                        onClick={() =>
                                          handleReconnect(
                                            connection.id,
                                            connection.host,
                                            connection.port,
                                            connection.systemId,
                                            connection.password,
                                            connection.bindingTON,
                                            connection.bindingNPI,
                                            connection.bindMode,
                                            connection.systemType,
                                            connection.addressRange,
                                            connection.transportProtocol
                                          )
                                        }
                                      >
                                        Reconnect
                                      </DropdownMenuItem>
                                    ) : null}

                                    <DropdownMenuSeparator />
                                    <DropdownMenuItem
                                      className="cursor-pointer"
                                      onClick={() =>
                                        handleEditConnection(connection.id)
                                      }
                                    >
                                      Edit
                                    </DropdownMenuItem>
                                    <DropdownMenuItem
                                      className="cursor-pointer"
                                      onClick={() =>
                                        handleDeleteConnection(connection.id)
                                      }
                                    >
                                      Delete
                                    </DropdownMenuItem>
                                  </DropdownMenuContent>
                                )}
                              </DropdownMenu>
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div className="flex items-center justify-center h-[500px]">
              <Button
                onClick={handleCreateConnection}
                className="w-36 text-sm font-thin h-[35px] mb-1"
              >
                Create Connection
              </Button>
            </div>
          )}

          <ConnectSMS
            open={open}
            handleClose={handleClose}
            checkIsAlive={checkIsAlive}
            connectionList={connectionList}
            isEditMode={isEdit}
            setIsEdit={setIsEdit}
            shortCodes={shortcodes}
          />
        </div>
      )}
    </>
  );
};

export default SmsConnections;
